import styled from 'styled-components';
import { font, query, space } from '@design/templateFns';

/*** STYLING ***/
export const ContentContainer = styled.div<{
  $backgroundColor?: string | boolean;
}>`
  margin: ${space('x10')} 0;
  margin-top: ${({ $backgroundColor }) =>
    $backgroundColor
      ? space('x10')
      : space('md')}; // change the margin top if there is no background color
`;

export const Header = styled.h1<{ $img?: string; $videoSrc?: string }>`
  text-align: center;
  margin-bottom: ${space('lg')};
  padding: 0 ${space('xl')};
  ${({ $videoSrc, $img }) => ($videoSrc || $img ? font('headline-sm') : font('headline-xs'))};

  @media (${query.atLeast('desktop')}) {
    ${({ $videoSrc, $img }) => ($videoSrc || $img ? font('headline-lg') : font('headline-md'))};
  }
`;

export const Caption = styled.p`
  ${font('body-sm-light')};
  max-width: 280px;
  text-align: center;
  margin: 0 auto;
  padding: 0;

  @media (${query.atLeast('tablet')}) {
    max-width: 450px;
  }

  @media (${query.atLeast('desktop')}) {
    ${font('body-md-light')};
    max-width: 550px;
  }
`;

export const Location = styled.p`
  ${font('eyebrow-sm')};
  max-width: 280px;
  text-transform: uppercase;
  text-align: center;
  margin: 0 auto;
  padding: 0;

  @media (${query.atLeast('tablet')}) {
    max-width: 450px;
  }

  @media (${query.atLeast('desktop')}) {
    ${font('eyebrow-md')};
    max-width: 550px;
  }
`;
